import { render, staticRenderFns } from "./DecretosNewOrEdit.vue?vue&type=template&id=6bc919b7&scoped=true&"
import script from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./DecretosNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./DecretosNewOrEdit.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./DecretosNewOrEdit.vue?vue&type=style&index=1&id=6bc919b7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc919b7",
  null
  
)

export default component.exports